var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbox-preview"},[_c('img',{ref:"img",attrs:{"src":_vm.thumbnail},on:{"load":_vm.onLoad}}),_c('div',{staticClass:"bbox-preview__outline",style:(_vm.bboxStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }